<template>
  <section id="hero" class="my-5 pt-3">
    <div class="container">
      <div class="row align-items-center">
        <!-- Mobile Banner -->
        <div
          class="col-sm-12 col-md-6 d-block d-sm-block d-md-none text-center my-3"
        >
          <img :src="heroImage" alt="hero-image" width="80%" />
        </div>
        <!-- End Mobile Banner -->
        <div class="col-sm-12 col-md-6">
          <h2>
            <strong>Delicious Food Menu,<br /></strong>
          </h2>

          <h2>in Your Gadget</h2>
          <p>Ayo segera pilih dan pesan makanan kamu</p>
          <router-link class="btn btn-lg btn-success" to="/foods">
            <b-icon icon="arrow-right-circle"></b-icon
            ><span class="ml-2">Pesan</span>
          </router-link>
        </div>
        <!-- Desktop Banner-->
        <div class="col-sm-12 col-md-6 d-none d-md-block">
          <img :src="heroImage" alt="hero-image" width="100%" />
        </div>
        <!-- End Dekstop Banner -->
      </div>
    </div>
  </section>
</template>

<script>
import Image from "../assets/images/hero.png";

export default {
  name: "Hero",
  data: function() {
    return {
      heroImage: Image,
    };
  },
};
</script>

<style scope></style>
